<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3 i18n>Contact</h3>
                    <ul class="contact-us-link">
                        <li class='bx bx-map'>
                            <a href="#" target="_blank" class="p-2"><span i18n>Firozkoh, Ghor, Afghanistan</span></a>
                        </li>
                        <li class='bx bx-phone-call'>
                                <a class="p-2" href="tel:+447447419596">00447447419596</a>
                                <a class="p-2" href="tel:+4915771009570">004915771009570</a>
                        </li>
                        <li class='bx bx-envelope'>
                            <a class="p-2" href="mailto:aleshansab&#64;gmail.com">aleshansab&#64;gmail.com</a>
                        </li>
                    </ul>
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/aleshansab" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3 i18n>History</h3>
                    <ul class="support-link">
                        <li><a routerLink="books/history/list" i18n>Books</a></li>
                        <li><a routerLink="/articles/history/list" i18n>Articles</a></li>
                        <li><a routerLink="biographies" i18n>Biography</a></li>
                        <li><a routerLink="news-papers" i18n>News Papers and Magazins</a></li>
                        <li><a routerLink="menuscripts" i18n>Menuscripts</a></li>
                            
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3 i18n>Culture</h3>
                    <ul class="useful-link">
                        <li><a routerLink="/articles/cloths/list" i18n>Cloths</a></li>
                        <li><a routerLink="/articles/jewelries/list" i18n>Jewelries</a></li>
                        <li><a routerLink="/articles/cermonies/list" i18n>Cermonies</a></li>
                        <li><a routerLink="/articles/sport_hobies/list" i18n>Sport and Hobies</a></li>
                        <li><a routerLink="/articles/chestans/list" i18n>Chestan</a></li>
                        <li><a routerLink="/articles/dubaities/list" i18n>Dubaities</a></li>
                        <li><a routerLink="/articles/fictions/list" i18n>Fictions</a></li>
                        <li><a routerLink="/articles/foods/list" i18n>Foods</a></li>
                        <li><a routerLink="/articles/agriculture/list" i18n>Agriculture</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom-area">
        <div class="container">
            <div class="logo">
                <a routerLink="/" class="d-inline-block"><img src="assets/img/logo.png" alt="image"></a>
            </div>
            <p>© Copyright is reserved by <a href="https://ale-shansab.com/" target="_blank">Ale-Shansab Research Foundation</a></p>
        </div>
    </div>
</footer>

<ngx-scrolltop></ngx-scrolltop>